import { css, cx } from "@emotion/css"

export function Loading(props: { className?: string }) {
  let center = 16
  let strokeWidth = 4
  let r = 16 - strokeWidth
  let c = 2 * r * Math.PI
  let offset = c - (1 / 4) * c

  return (
    <div
      className={cx(
        css`
          /* padding: 1rem; */
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        `,
        props.className,
      )}
    >
      <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        strokeWidth={strokeWidth}
      >
        <circle
          role="presentation"
          cx={center}
          cy={center}
          r={r}
          stroke="#98dfda"
        />
        <circle
          role="presentation"
          cx={center}
          cy={center}
          r={r}
          stroke="#00b1a3"
          strokeDasharray={c}
          strokeDashoffset={offset}
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            begin="0s"
            dur="1s"
            from="0 16 16"
            to="360 16 16"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  )
}
